export default __webpack_public_path__ + "static/media/1.ea22e7c8.svg";